/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAction, props } from '@ngrx/store';
import { UserInfo } from '../..';

export const loadUserInfo = createAction('[User] loadUserInfo');
export const loadUserInfoSuccess = createAction('[User] loadUserInfoSuccess', props<{ user: UserInfo | null }>());
export const loadUserInfoError = createAction('[User] loadUserInfoError', props<{ payload: any }>());
